import {TableCell, TableRow} from "../../../components/table/CustomTable";
import {capitalizeFirstLetter} from "../../../helpers/stringHelper";
import React from "react";

const statusStyle = (status) => {
  if (status === "COMPLETED" || status === "SUCCESS") {
    return "bg-green-100 text-primary-800"
  } else if (status === "CANCELLED") {
    return "bg-red-100 text-error-500"
  } else if (status === "BOOKED" || status === "INITIATED") {
    return "bg-secondary-200 text-cyan-700"
  } else if (status === "ASSIGNED") {
    return "bg-blue-100 text-secondary-500"
  } else {
    return "bg-yellow-100 text-yellow-500"
  }
}

const CampaignReportItem = ({campaignItem}) => {
  const campaign = campaignItem
  const fullName = (person) => {
    return `${capitalizeFirstLetter(person.first_name)} ${capitalizeFirstLetter(person.last_name)}`
  }

  return <TableRow>
    <TableCell>
      <div className="w-54">
        {campaign.campaign.title}
      </div>
    </TableCell>
    <TableCell>
      {fullName(campaign.requested_by)}
    </TableCell>
    <TableCell>
      <div className="font-semibold whitespace-nowrap">
        {campaign.appointment_date}
      </div>
    </TableCell>
    <TableCell>
      <span
        className={`${statusStyle(campaign.payment.status)}  font-semibold rounded text-xs py-1 px-2 font-semibold tracking-wide`}>
        {campaign.payment.status == "SUCCESS" ? "Paid" : "Pending"}
      </span>
    </TableCell>
    <TableCell className="text-right whitespace-nowrap">
      Rs. {campaign.payment?.price ?? "N/A"}
    </TableCell>
    <TableCell>
      <span
        className={`${statusStyle(campaign.status)} rounded text-xs py-1 px-2 font-semibold tracking-wide`}>{capitalizeFirstLetter(campaign.status)}
                      </span>
    </TableCell>
  </TableRow>
}

export default CampaignReportItem